import React, { memo } from 'react';

import { areEqualShallow } from 'Utils/equalityChecks';
import Recon from '../../../../Assets/recon.svg';

// Custom css
import classes from './recon.module.css';

interface Props {
  className?: string;
  id?: string;
  onClick?: (e: any) => void;
  onKeyUp?: (e: any) => void;
}
function ReconSvg({ className = '', id, onClick, onKeyUp }: Props) {
  return <Recon id={id} className={`${classes.reconBase} ${className || ''}`} onClick={onClick} onKeyUp={onKeyUp} />;
}

ReconSvg.defaultProps = {
  className: undefined,
  id: undefined,
  onClick: undefined,
  onKeyUp: undefined,
};

const ReconSvgMemo = memo(ReconSvg, areEqualShallow);
export { ReconSvgMemo as ReconSvg };
